import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ZoomProvider } from './contexts/ZoomContext.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ZoomProvider>
      <App />
    </ZoomProvider>
  </React.StrictMode>,
)
